<template>
  <v-content>
    <v-dialog
      v-model="dialog.isShow"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          {{dialog.title}}
        </v-card-title>

        <v-card-text>
          {{dialog.content}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="dialog.isShow = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar class="bg-color" dark extended flat>
      <v-btn dark icon @click="goHome()">
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </v-toolbar>
    <v-layout wrap column pb-2 justify-center>
      <v-flex xs12 sm10 md8>
        <v-flex xs12 d-flex justify-center>
          <v-card class="card--flex-toolbar" style="max-width:750px">
            <v-toolbar card prominent>
              <v-toolbar-title class="body-2 grey--text">Account Registration</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 sm7>
                  <v-card-title class="pb-0">
                    <div>
                      <h3 class="headline mb-0">Create your Crio Pilot Account</h3>
                      <span class="grey--text"></span>
                    </div>
                  </v-card-title>
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="submit">
                    <v-container fluid grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm6>
                          <v-text-field v-model="registration.firstName" :rules="[formRules.required]" label="First name" required></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field v-model="registration.lastName" :rules="[formRules.required]" label="Last name" required></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field v-model="registration.email" :rules="[formRules.requiredEmail]" label="E-mail" hint="Please use your institution email" required></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-select v-model="registration.emailDomain" prefix="@" :items="allowedEmailDomains"></v-select>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field v-model="registration.password" :rules="[formRules.required, formRules.lengthPassword]" type="password" label="Password" hint="Please use at least 8 characters" required></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field v-model="registration.confirmPassword" :rules="[formRules.valuePassword]" type="password" label="Confirm" required></v-text-field>
                        </v-flex>
                        <v-layout xs12 justify-space-between class="mt-3">
                          <v-btn color="teal" class="white--text" :disabled="!valid" @click="submit()">Register</v-btn>
                        </v-layout>
                        <v-flex xs12></v-flex>
                        <v-flex xs12>
                          <p>If you have problem registering, you may also request a pilot account by sending an email to <a href="mailto:kevinchan@hksyu.edu?subject=Request%20for%20Crio%20pilot%20account">kevinchan@hksyu.edu</a></p>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-flex>
                <v-flex xs12 sm5 class="hidden-xs-only pt-5">
                  <v-img contain class="ma-3" src="/assets/key.png"></v-img>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 d-flex justify-center>
          <v-layout class="my-2" style="max-width:750px">
            <v-btn flat small color="grey" @click="goForgetPassword">Forgot Password?</v-btn>
            <v-btn flat small color="grey" @click="goResendVerification">No verification email?</v-btn>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
  import validator from 'validator';
  export default {
    props: {
      navigateTo: Function
    },
    data() {
      return {
        dialog: {
          isShow: false,
          title: '',
          content: '',
        },
        isConfirmed: false,
        formRules: {
          required: v => !!v || 'This field is required',
          requiredEmail: v => !!v || 'A valid email address is required',
          formatEmail: v => validator.isEmail(v) || 'Invalid email address',
          formatLoginName: (v) => {
            const letterNumberOnly = new RegExp('^([a-zA-Z0-9-_.@]+)$');
            const atleastthreeletterNum = new RegExp('^.*[a-zA-Z0-9]+.*$');
            if (v.length < 3) {
              return 'Your username should be at least 3 characters long';
            }
            if (!atleastthreeletterNum.test(v) || !letterNumberOnly.test(v)) {
              return 'Your username should be composed of alphabets, numbers or the symbols - _ . @';
            }
            return true;
          },
          lengthPassword: v => v.length >= 8  || 'Your password should be at least 8 characters long',
          valuePassword: v => v === this.registration.password || 'Your passwords do not match',
        },
        valid: false,
        registration: {
          firstName: '',
          lastName: '',
          email: '',
          emailDomain: 'hksyu.edu',
          password: '',
          confirmPassword: '',
        },
        hideReferenceField: !!(this.$route.query.ref),
        allowedEmailDomains: [
          'uow.edu.au',
          'cihe.edu.hk',
          'caps.cihe.edu.hk',
          'mail.cihe.edu.hk',
          'staff.cihe.edu.hk',
          'cbcc.edu.hk',
          'mail.cbcc.edu.hk',
          'sfu.edu.hk',
        ],
      };
    },
    computed: {
      registrationEmail: function() {
        return `${this.registration.email}@${this.registration.emailDomain}`;
      }
    },
    methods: {
      submit() {
        let self = this;
        if (this.$refs.form.validate()) {
          // Native form submission is not yet supported
          this.axios.post('public/register', {
            username: this.registrationEmail,
            firstName: this.registration.firstName,
            lastName: this.registration.lastName,
            email: this.registrationEmail,
            password: this.registration.password,
          }).then(() => {
            self.dialog.title = 'Registration successful';
            self.dialog.content = 'Registration successful. Please check your mailbox to verify your email.';
            self.dialog.isShow = true;
          }).catch((err) => {
            if (err.response.status === 409) {
              self.dialog.title = 'Email address already used';
              self.dialog.content = 'Your email address is already used to register an account. Please login or reset your password.';
              self.dialog.isShow = true;
            } else if (err.response.status === 403) {
              self.dialog.title = 'Invalid invitation code';
              self.dialog.content = 'You need a valid invitation code to register as a guest.';
              self.dialog.isShow = true;
            } else {
              self.dialog.title = 'Registration failed';
              self.dialog.content = 'Registration failed. Please check your information.';
              self.dialog.isShow = true;
            }
          });
        }
      },

      goHome() {
        window.history.back();
      },
      goForgetPassword() {
        this.$router.push({name: 'ForgetPassword'});
      },
      goResendVerification() {
        this.$router.push({name: 'ResendVerify'});
      },
    }
  };
</script>

